var changedFlag = true;

var outOfStock = false;

var outOfStockLoc = [];

var appLoad = true;

var userCity = "";

var PaLocation = "";
var DeLocation = "";

var selectedInv = "";

var fakeCheckbox = false;

var selector =
  "#" +
  document.querySelector(".ProductForm__Item").getAttribute("aria-controls");

window.addEventListener("DOMContentLoaded", () => {
  var originalOptions = [];

  $.getJSON("https://bullseyesb.online/locations", function (data) {
    let arr = data.locations;
    const searchTerms = ["Christiana Mall", "Capital City Plaza"];
    let result = arr.filter((obj) => searchTerms.includes(obj.name));

    for (let loc of result) {
      if (loc.province_code == "PA") {
        PaLocation += `<p>${loc.address1} <br> ${loc.city} ${loc.province_code} ${loc.zip} <br> ${loc.country_name}</p>`;
      }
      if (loc.province_code == "DE") {
        DeLocation += `<p>${loc.address1} <br> ${loc.city} ${loc.province_code} ${loc.zip} <br> ${loc.country_name}</p>`;
      }
    }
  });

  var divs = document.querySelector(selector).querySelectorAll("button.u-h6");
  originalOptions = divs;

  for (let element of divs) {
    var matches = element.innerHTML.match(/\((.*?)\)/g);
    if (matches) {
      if (matches.includes("(No Box)")) {
        element.innerHTML =
          element.innerHTML.replace(/\(.*\)|\[.*\]/, "").trim() + " No Box";
      } else {
        element.innerHTML = element.innerHTML
          .replace(/\(.*\)|\[.*\]/, "")
          .trim();
      }
    }
  }

  for (let element of divs) {
    let count = 0;
    for (let em of divs) {
      if (em.innerHTML == element.innerHTML) {
        if (count >= 1) {
          em.style.display = "none";
          if (element.getAttribute("hide-positions")) {
            element.setAttribute(
              "hide-positions",
              element.getAttribute("hide-positions") +
                "," +
                em.getAttribute("data-value")
            );
          } else {
            element.setAttribute(
              "hide-positions",
              em.getAttribute("data-value")
            );
          }
        }
        count++;
      }
    }
  }

  var checkAvail = document
    .querySelector(selector)
    .querySelectorAll("button.u-h6");

  for (let element of checkAvail) {
    // console.log(element)
    let selected = element.getAttribute("data-value");
    // console.log(selected)
    if (selected) {
      var gv = getVariant(selected.replace(/ /g, ""));
      let allhidden = element.getAttribute("hide-positions");
      if (allhidden) {
        if ($(gv).attr("disabled")) {
          let myArray = allhidden.split(",");
          let count = 0;
          for (let opt of myArray) {
            var getMatch = opt.match(/\((.*?)\)/g);
            let gvh = getVariant(opt.replace(/ /g, ""));
            if ($(gvh).attr("disabled")) {
              count++;
            }
          }
          if (myArray.length == count) {
            $(element).hide();
          }
        }
      } else {
        if ($(gv).attr("disabled")) {
          $(element).hide();
        }
      }
    }
  }

  selectedInv = document
    .querySelector(selector)
    .querySelector("button.u-h6.is-selected");

  showLocations(selectedInv);

  setTimeout(function () {
    selectedVal();
  }, 1000);

  $(selector + " button.u-h6").click(function (e) {
    let b6 = this;
    selectedInv = b6;
    if (e.hasOwnProperty("originalEvent")) {
      if (e.originalEvent.isTrusted) {
        changedFlag = true;
      }
    }
    console.log("changing variant");
    console.log(b6);
    showLocations(b6);
  });

  $(".locations input").click(function (e) {
    if (e.originalEvent) {
      fakeCheckbox = false;
    } else {
      fakeCheckbox = true;
    }
  });

  $(".locations input").change(function (e) {
    if (fakeCheckbox == false) {
      let t = this;
      selectV($(t).val());
    }
  });
});

var possibleOthers = [
  "",
  "(AH)",
  "(Ben)",
  "(DO)",
  "(HS)",
  "(TB)",
  "(MJ)",
  "(LJ)",
  "(CG)",
  "(AM)",
  "(CJ)",
  "(MP)",
  "(MA)",
  "(Smoke)",
  "(Smokey)",
  "(Swervo)",
  "(JL)",
  "(ZD)",
  "(Laura)",
  "(Roman)",
  "(MM)",
  "(JO)",
  "(AV)",
  "(JR)",
  "(CR)",
  "(IB)",
  "(DG)",
  "(Christiana)",
  "(Labar)",
  "(Joe)",
  "(Krauss)",
  "(Nash)",
  "(Strafford)",
  "(Adam)",
  "(Ryan)",
  "(Nash)",
  "(CM)",
];

function selectV(loc) {
  let ck = document.querySelector(".ProductForm__SelectedValue").innerHTML;

  if (loc == "PA") {
    let fv = document.querySelector(
      `button[data-value='${ck.replace(/\(.*\)|\[.*\]/, "") + "(PA)"}']`
    );

    if (!fv) {
      fv = document.querySelector(
        `button[data-value='${ck.replace(/\(.*\)|\[.*\]/, "") + " (PA)"}']`
      );
    }

    if (fv) {
      fv.click();

      setTimeout(function () {
        if (
          !$(".store-availability-information svg path").attr("stroke-linecap")
        ) {
          getInventory("(PA)", ck.replace(/\(.*\)|\[.*\]/, ""));
        }
      }, 200);
    } else {
      for (let i of possibleOthers) {
        let f = getVariant(`${ck.replace(/\(.*\)|\[.*\]/, "") + "(PA)" + i}`);
        if (f) {
          if (!$(f).attr("disabled")) {
            fv = document.querySelector(
              `button[data-value='${
                ck.replace(/\(.*\)|\[.*\]/, "") + " (PA) " + i
              }']`
            );
            fv.click();
          }
        }
      }
    }
  }
  if (loc == "DE") {
    let fv = document.querySelector(
      `button[data-value='${ck.replace(/\(.*\)|\[.*\]/, "") + "(DE)"}']`
    );

    if (!fv) {
      fv = document.querySelector(
        `button[data-value='${ck.replace(/\(.*\)|\[.*\]/, "") + " (DE)"}']`
      );
    }

    if (fv) {
      fv.click();

      setTimeout(function () {
        if (
          !$(".store-availability-information svg path").attr("stroke-linecap")
        ) {
          getInventory("(DE)", ck.replace(/\(.*\)|\[.*\]/, ""));
        }
      }, 200);
    } else {
      for (let i of possibleOthers) {
        let f = getVariant(`${ck.replace(/\(.*\)|\[.*\]/, "") + "(DE)" + i}`);
        if (f) {
          if (!$(f).attr("disabled")) {
            fv = document.querySelector(
              `button[data-value='${
                ck.replace(/\(.*\)|\[.*\]/, "") + " (DE) " + i
              }']`
            );
            fv.click();
          }
        }
      }
    }
  }

  if ($(".ProductForm__SelectedValue")) {
    let elementval = document.querySelector(".ProductForm__SelectedValue");
    var matches = elementval.innerHTML.match(/\((.*?)\)/g);

    if (matches) {
      if (matches.includes("(No Box)")) {
        document.querySelector(".ProductForm__SelectedValue").textContent =
          document
            .querySelector(".ProductForm__SelectedValue")
            .innerHTML.replace(/\(.*\)|\[.*\]/, "")
            .trim() + " No Box";
      } else {
        document.querySelector(".ProductForm__SelectedValue").textContent =
          document
            .querySelector(".ProductForm__SelectedValue")
            .innerHTML.replace(/\(.*\)|\[.*\]/, "")
            .trim();
      }
    }
  }
}

function showLocations(div) {
  outOfStockLoc.length = 0;
  outOfStock = false;
  $(".locations").show();
  $(".locations #PA").show();
  $(".locations #DE").show();
  $(".locations #PA span").hide();
  $(".locations #DE span").hide();

  $("#PA input").prop("disabled", true);
  $("#DE input").prop("disabled", true);

  setTimeout(function () {
    let selected = div.getAttribute("data-value");
    let allhidden = div.getAttribute("hide-positions");
    let found = [];
    let sfound = [];
    if (allhidden) {
      console.log('all hidden', allhidden);
      let myArray = allhidden.split(",");
      myArray.push(selected);
      let paFlag = false;
      console.log(myArray)
      for (let opt of myArray) {
        var getMatch = opt.match(/\((.*?)\)/g);
        console.log('getMatch', getMatch)
        if (getMatch) {
          if (getMatch.includes("(DE)") || getMatch.includes("DE")) {
            found.push(opt);
            showSelected(opt, "DE");
          }
          if (getMatch.includes("(PA)") || getMatch.includes("PA")) {
            found.push(opt);
            console.log('else PA:', !paFlag, $("#PA input").prop("disabled"), (!paFlag || $("#PA input").prop("disabled")))
            if (!paFlag || $("#PA input").prop("disabled")) {
              paFlag = true;
              showSelected(opt, "PA");
            }
          }
        }
      }
    } else {
      $(".locations #PA span").show();
      $(".locations #DE span").show();
      var getMatch = selected.match(/\((.*?)\)/g);
      if (getMatch) {
        if (getMatch.includes("(DE)") || getMatch.includes("DE")) {
          found.push(selected);
          showSelected(selected, "DE");
        }
        if (getMatch.includes("(PA)") || getMatch.includes("PA")) {
          found.push(selected);
          showSelected(selected, "PA");
        }
      }
    }

    var invenCheck = "";

    if (selected.includes("(PA)")) {
      console.log("inv check if",selected.includes("(PA)"))
      invenCheck = "DE";
      if ($("#DE input").prop("disabled")) {
        verifyInventory("(DE)", selected);
      }
    } else {
      console.log("inv check else")
      invenCheck = "PA";
      if ($("#PA input").prop("disabled")) {
        verifyInventory("(PA)", selected);
      }else{
        verifyInventory("(PA)", selected)
      }
    }
  }, 100);
  setTimeout(selectedVal, 200);
}

function verifyInventory(type, selected) {
  let found = false;
  for (let i of possibleOthers) {
    let f = getVariant(
      `${selected.replace(/\(.*\)|\[.*\]/, "") + type + i}`.replace(/ /g, "")
    );
    console.log(f)
    if (f) {
      if (!$(f).attr("disabled")) {
        found = true;
        $(`#${type.replace(/[^a-zA-Z0-9 ]/g, "")} input`).prop(
          "disabled",
          false
        );
        $(`#${type.replace(/[^a-zA-Z0-9 ]/g, "")} span`).hide();

        console.log('FOUND:',$(`#${type.replace(/[^a-zA-Z0-9 ]/g, "")} input`));
      }
    }
  }
  if (!found) {
    $(`#${type.replace(/[^a-zA-Z0-9 ]/g, "")} input`).prop("disabled", true);
    $(`#${type.replace(/[^a-zA-Z0-9 ]/g, "")} span`).show();
  }
}

function getInventory(type, selected) {
  let found = false;
  for (let i of possibleOthers) {
    let f = getVariant(`${selected + type + i}`.replace(/ /g, ""));

    if (f) {
      if (!$(f).attr("disabled")) {
        found = true;
        let single = false;
        if (f) {
          var ii = getNodeIndex(f);
        } else {
          var ii = 0;
          single = true;
        }

        let sv = document.querySelectorAll("button.Custom")[ii];
        // console.log(sv)
        sv.click();
      }
    }
  }
}

function showSelected(opt, type) {
  console.log('opt', opt);
  console.log('type', type)
  let v = getVariant(opt.replace(/ /g, ""));
  console.log('Vasdasd : ',$(v));
  // console.log(opt, opt.replace(/ /g, ""))
  let single = false;
  if (v) {
    var i = getNodeIndex(v);
  } else {
    var i = 0;
    single = true;

    console.log("variant not found");
  }
  let sv = document.querySelectorAll("button.Custom")[i];
  console.log('saasdasdvvvv: ',sv)
  // console.log(type)
  
  console.log($(v).attr("disabled"))
  
  if ($(v).attr("disabled") == 'disabled' && $(v).attr("disabled") !== undefined) {
    console.log("found disabled",type)
    $(`.locations #${type} span`).show();
    $(`#${type} input`).attr("disabled", true);
    document.querySelector(`#${type} input`).setAttribute('disabled', true);
    if (
      !$(`#${type} input`).is(":disabled")
    ){
      $(`#${type} input`).attr("disabled", true);  
    }
    
    console.log($(`#${type} input`))
  } else {
    console.log("selecting",type)
    // console.log(changedFlag)
    $(`#${type} input`).attr("disabled", false);
    $(`#${type} span`).hide();

    console.log($(`#${type} input`))
  }

  console.log('before location', !$(".locations").attr("run"))

  if (!$(".locations").attr("run")) {
    $(".locations").attr("run", true);
  } else {
    if ($("#DE span").is(":hidden") && !$("#PA input").is(":checked")) {
      $(`#DE input`).attr("disabled", false);
      $("#DE span").hide();
    }
    if ($("#PA span").is(":hidden") && !$("#DE input").is(":checked")) {
      $(`#PA input`).attr("disabled", false);
      $("#PA span").hide();
    }
  }

  console.log('after location: ', $(`#${type} input`).is(":checked"), $(`#${type} input`).is(":disabled"))

  if (
    $(`#${type} input`).is(":checked") &&
    $(`#${type} input`).is(":disabled")
  ) {
    // console.log("Wrong value selected")
    // console.log($(`#PA input`).attr("value"))
    // console.log($(`#PA input`).is(":disabled"))
    if ($(`#PA input`).attr("value") == "PA") {
      $("#DE").click();
      // return;
    }
  } else {
    console.log('PA input: ', $(`#PA input`).is(":disabled"))
    console.log('DE input: ', $(`#DE input`).is(":disabled"))
    if ($(`#PA input`).is(":disabled")) {
      $("#DE").click();
      // return;
    }
    if ($(`#DE input`).is(":disabled")) {
      $("#PA").click();
      // return;
    }
    // if($('.ProductForm__BuyButtons button').is(":disabled"))
    // {
    //   $("#PA").click();
    // }

    // setTimeout(()=>{
    //   if($('.ProductForm__BuyButtons button').is(":disabled"))
    //   {
    //     $("#DE").click();
    //   }
    // },500)
    // return;
  }

  console.log('line 495')

  console.log('line 497:', $(`#PA input`).is(":checked") &&
    !document
      .querySelector('option[selected="selected"]')
      .getAttribute("data-sku")
      .includes("PA"), $(`#PA input`).is(":checked") ,
    !document
      .querySelector('option[selected="selected"]')
      .getAttribute("data-sku")
      .includes("PA"))
  if (
    $(`#PA input`).is(":checked") &&
    !document
      .querySelector('option[selected="selected"]')
      .getAttribute("data-sku")
      .includes("PA")
  ) {
    // console.log("wrong value selected new check PA");
    // $("#DE").click();
    $("#PA").click();
    $("#PA input").change();
  }

  console.log('line 519',$(`#DE input`).is(":checked") &&
    !document
      .querySelector('option[selected="selected"]')
      .getAttribute("data-sku")
      .includes("DE"),$(`#DE input`).is(":checked") ,
    !document
      .querySelector('option[selected="selected"]')
      .getAttribute("data-sku")
      .includes("DE"));
  
  if (
    $(`#DE input`).is(":checked") &&
    !document
      .querySelector('option[selected="selected"]')
      .getAttribute("data-sku")
      .includes("DE")
  ) {
    // console.log("wrong value selected new check DE");
    // $("#PA").click();
    $("#DE").click();
    $("#DE input").change();
  }

  if($(`#DE input`).is(":disabled") && $(`#DE input`).is(":checked")){
    console.log('DE is disabled and check')

    if($(`#PA input`).is(":disabled")){
      // console.log("PA is also disabled")
    }else{
      $("#PA").click();
    }
  }

  if($('.ProductForm__BuyButtons button').is(":disabled"))
    {
      $("#PA").click();
    }

    setTimeout(()=>{
      if($('.ProductForm__BuyButtons button').is(":disabled"))
      {
        $("#DE").click();
      }
    },500)
}

function getVariant(selected) {
  var options = document
    .querySelector("select[title='Variant']")
    .querySelectorAll("option");
  // console.log(options)
  for (let option of options) {
    let getText = option.innerHTML.replace(/ /g, "").split("-");
    let getText2 = option.innerHTML.match(/\((.*?)\)/g);

    let xcheck = false;
    // console.log(selected);
    if (selected.includes("X")) {
      console.log("variant with X");
      xcheck = true;
    } else if (selected.includes("XX")) {
      // console.log("variant with XX");
      xcheck = true;
    } else {
      xcheck = false;
      // console.log("variant without X");
    }

    // console.log(getText);
    // console.log(getText2);
    if (getText.length == 2 && getText.includes(selected)) {
      return option;
      break;
    } else if (getText.length == 3 && xcheck) {
      // return option;
      // break;
    } else {
      // console.log("else started");
      let selectedsplit = selected.replace(/ /g, "").split("-");
      // console.log(selectedsplit);
      if (selectedsplit.length == 2) {
        if (getText.includes(selectedsplit[1])) {
          return option;
          break;
        }
      } else if (getText.length == 3) {
        // console.log("new condition");
        // console.log(getText[0] + getText[1]);
        // console.log(selected);
        if (selected == getText[0] + getText[1]) {
          // console.log("found with new logic");
          return option;
          break;
        }
      }
    }
  }
}

function getNodeIndex(node) {
  var index = 0;
  while ((node = node.previousSibling)) {
    if (node.nodeType != 3 || !/^\s*$/.test(node.data)) {
      index++;
    }
  }
  return index;
}

function waitForElementToDisplay(
  selector,
  callback,
  checkFrequencyInMs,
  timeoutInMs
) {
  var startTimeInMs = Date.now();
  (function loopSearch() {
    if (document.querySelector(selector) != null) {
      callback();
      return;
    } else {
      setTimeout(function () {
        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) return;
        loopSearch();
      }, checkFrequencyInMs);
    }
  })();
}

function selectedVal() {
  if ($(".ProductForm__SelectedValue")) {
    let elementval = document.querySelector(".ProductForm__SelectedValue");
    var matches = elementval.innerHTML.match(/\((.*?)\)/g);

    if (matches) {
      if (matches.includes("(No Box)")) {
        document.querySelector(".ProductForm__SelectedValue").textContent =
          document
            .querySelector(".ProductForm__SelectedValue")
            .innerHTML.replace(/\(.*\)|\[.*\]/, "")
            .trim() + " No Box";
      } else {
        document.querySelector(".ProductForm__SelectedValue").textContent =
          document
            .querySelector(".ProductForm__SelectedValue")
            .innerHTML.replace(/\(.*\)|\[.*\]/, "")
            .trim();
      }
    }
  }
  if (userCity != "") {
    // getDistance(userCity);
  }

  if (!$("#DE span").is(":hidden") && !$("#PA span").is(":hidden")) {
    // waitForElementToDisplay(".store-availability-information__title strong", function() {
    //     $(".store-availability-information__title").text("Pickup currently unavailable")
    // }, 1000, 15000);
  }
}

// calculate distance
function calculateDistance(dest, dest2, org) {
  changedFlag = false;
  var origin = org;
  var destination = dest;
  var service = new google.maps.DistanceMatrixService();
  //console.log(service)
  service.getDistanceMatrix(
    {
      origins: [origin],
      destinations: [destination, dest2],
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.IMPERIAL, // miles and feet.
      avoidHighways: false,
      avoidTolls: false,
    },
    callbackApi
  );
}
// get distance results
function callbackApi(response, status) {
  // console.log(response);
  // console.log(status);
  if (status != google.maps.DistanceMatrixStatus.OK) {
  } else {
    let allres = response.rows[0].elements;
    if (allres[0].status == "ZERO_RESULTS") {
      // console.log("No result for PA")
    }
    if (allres[1].status == "ZERO_RESULTS") {
      // console.log("No result for DE")
    }

    if (
      allres[0].hasOwnProperty("distance") &&
      allres[1].hasOwnProperty("distance")
    ) {
      if (allres[0].distance.value > allres[1].distance.value) {
        $("#DE").click();
      } else {
        $("#PA").click();
      }
    }
  }
}

function getDistance(current) {
  let loc1 = "3401 Hartzdale Dr Suite 117, Camp Hill, PA 17011";
  let loc2 = "604 Christiana Mall";
  // console.log("Getting distance")
  if (changedFlag || appLoad) {
    appLoad = false;
    if (
      $("#PA input").prop("disabled") == false &&
      $("#DE input").prop("disabled") == false
    ) {
      $("#DE input").prop("checked", true).trigger("change");
    } else {
      if ($("#PA input").prop("disabled") == false) {
        $("#PA input").prop("checked", true).trigger("change");
      } else {
        if ($("#DE input").prop("disabled") == false) {
          $("#DE input").prop("checked", true).trigger("change");
        }
      }
    }
  }

  setTimeout(function () {
    if (outOfStock) {
      changedFlag = false;
    }
    // console.log(changedFlag)
    if (changedFlag) {
      changedFlag = false;
      // console.log("PA Clicked")
      $("#PA").click();
      // calculateDistance(loc1, loc2, current);
    }
  }, 1000);
}

waitForElementToDisplay(
  ".ProductForm__Variants",
  function () {
    userCity = "";
    getDistance(userCity);
    // fetch(
    //   "https://api.bigdatacloud.net/data/ip-geolocation?key=bdc_bc3e5952cbe14156b264a72fa0159b65"
    // )
    //   .then((response) => response.json())
    //   .then((jsonResponse) => {
    //     console.log(jsonResponse);
    //     changedFlag = true;
    //     try {
    //       userCity =
    //         jsonResponse.location.postcode +
    //         " " +
    //         jsonResponse.country.isoAlpha2;
    //       console.log(userCity);
    //       getDistance(userCity);
    //     } catch (e) {
    //       console.log("Api Not Working");
    //       console.log(e);
    //     }
    //   });
  },
  1000,
  15000
);

function containsAny(str, substrings) {
  for (var i = 0; i != substrings.length; i++) {
    var substring = substrings[i];
    if (str.indexOf(substring) != -1) {
      //   console.log(substring)
      str = str.replace(substring, "");
    }
  }
  return str;
}

var possibleOtherss = [
  "(PA)",
  "(DE)",
  "(CM)",
  "(AH)",
  "(Ben)",
  "(DO)",
  "(HS)",
  "(TB)",
  "(MJ)",
  "(LJ)",
  "(CG)",
  "(AM)",
  "(CJ)",
  "(Smoke)",
  "(Smokey)",
  "(Swervo)",
  "(JL)",
  "(ZD)",
  "(Laura)",
  "(Roman)",
  "(MM)",
  "(MP)",
  "(JO)",
  "(AV)",
  "(JR)",
  "(CR)",
  "(IB)",
  "(DG)",
  "(Christiana)",
  "(Labar)",
  "(Joe)",
  "(Krauss)",
  "(Nash)",
  "(Strafford)",
  "(Adam)",
  "(Ryan)",
  "(Nash)",
];
var targetNode = document.getElementById("sidebar-cart");
var observer = new MutationObserver(function () {
  if (targetNode.style.visibility != "hidden") {
    // console.log("Merge it")
    var getCartItems = document.querySelectorAll(".CartItem__Variant");
    for (let item of getCartItems) {
      var result = containsAny(item.textContent, possibleOtherss);
      // console.log(result);
      item.textContent = result;
    }
    // console.log(possibleOthers)
    // console.log(getCartItems)
  }
});
observer.observe(targetNode, { attributes: true, childList: true });
